import { render } from "./audio-attachment.vue?vue&type=template&id=5102b26f"
import script from "./audio-attachment.vue?vue&type=script&lang=js"
export * from "./audio-attachment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__